import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCancelledBookingList = createAsyncThunk(
  "cancelledBookingList/getCancelledBookingList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customer/cancel_booking`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const cancelledBookingSlice = createSlice({
  name: "cancelledBookingList",
  initialState: {
    loading: false,
    cancelledBookingData: null,
    error: null,
  },
  reducers: {
    ResetCancelledBooking: (state) => {
      state.cancelledBookingData = null; // Clear old data
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCancelledBookingList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCancelledBookingList.fulfilled, (state, action) => {
        state.loading = false;
        state.cancelledBookingData = action.payload;
      })
      .addCase(getCancelledBookingList.rejected, (state, action) => {
        state.loading = false;
        state.cancelledBookingData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetCancelledBooking } = cancelledBookingSlice.actions;
export default cancelledBookingSlice.reducer;
